var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3633 0H2.63672C1.1799 0 0 1.18723 0 2.63672V18.457C0 19.9151 1.18857 21.0938 2.63672 21.0938H27.3633C28.8079 21.0938 30 19.9201 30 18.457V2.63672C30 1.1898 28.8248 0 27.3633 0ZM26.994 1.75781L16.8645 11.834C16.3664 12.3321 15.7043 12.6063 15 12.6063C14.2957 12.6063 13.6336 12.332 13.1339 11.8324L3.00598 1.75781H26.994ZM1.75781 18.0993V2.99561L9.35379 10.5516L1.75781 18.0993ZM3.00709 19.3359L10.6001 11.7912L11.8926 13.077C12.7226 13.907 13.8262 14.3641 15 14.3641C16.1738 14.3641 17.2774 13.907 18.1058 13.0786L19.3999 11.7912L26.9929 19.3359H3.00709ZM28.2422 18.0993L20.6462 10.5516L28.2422 2.99561V18.0993Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSvg);
export default __webpack_public_path__ + "static/media/mail-svg.a88254bd4d66abcd379c973a593ddb8d.svg";
export { ForwardRef as ReactComponent };